// source: mlmbox/client/session/v1/session.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var mlmbox_type_session_pb = require('../../../../mlmbox/type/session_pb.js');
goog.object.extend(proto, mlmbox_type_session_pb);
var mlmbox_type_time_point_pb = require('../../../../mlmbox/type/time_point_pb.js');
goog.object.extend(proto, mlmbox_type_time_point_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
goog.exportSymbol('proto.mlmbox.client.session.v1.SessionStateGetResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.mlmbox.client.session.v1.SessionStateGetResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.mlmbox.client.session.v1.SessionStateGetResponse.repeatedFields_, null);
};
goog.inherits(proto.mlmbox.client.session.v1.SessionStateGetResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.mlmbox.client.session.v1.SessionStateGetResponse.displayName = 'proto.mlmbox.client.session.v1.SessionStateGetResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.mlmbox.client.session.v1.SessionStateGetResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.mlmbox.client.session.v1.SessionStateGetResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.mlmbox.client.session.v1.SessionStateGetResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.mlmbox.client.session.v1.SessionStateGetResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.client.session.v1.SessionStateGetResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    current: (f = msg.getCurrent()) && mlmbox_type_session_pb.Session.toObject(includeInstance, f),
    othersList: jspb.Message.toObjectList(msg.getOthersList(),
    mlmbox_type_session_pb.Session.toObject, includeInstance),
    expireDuration: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.mlmbox.client.session.v1.SessionStateGetResponse}
 */
proto.mlmbox.client.session.v1.SessionStateGetResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.mlmbox.client.session.v1.SessionStateGetResponse;
  return proto.mlmbox.client.session.v1.SessionStateGetResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.mlmbox.client.session.v1.SessionStateGetResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.mlmbox.client.session.v1.SessionStateGetResponse}
 */
proto.mlmbox.client.session.v1.SessionStateGetResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new mlmbox_type_session_pb.Session;
      reader.readMessage(value,mlmbox_type_session_pb.Session.deserializeBinaryFromReader);
      msg.setCurrent(value);
      break;
    case 2:
      var value = new mlmbox_type_session_pb.Session;
      reader.readMessage(value,mlmbox_type_session_pb.Session.deserializeBinaryFromReader);
      msg.addOthers(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setExpireDuration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.mlmbox.client.session.v1.SessionStateGetResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.mlmbox.client.session.v1.SessionStateGetResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.mlmbox.client.session.v1.SessionStateGetResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.mlmbox.client.session.v1.SessionStateGetResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      mlmbox_type_session_pb.Session.serializeBinaryToWriter
    );
  }
  f = message.getOthersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      mlmbox_type_session_pb.Session.serializeBinaryToWriter
    );
  }
  f = message.getExpireDuration();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
};


/**
 * optional mlmbox.type.Session current = 1;
 * @return {?proto.mlmbox.type.Session}
 */
proto.mlmbox.client.session.v1.SessionStateGetResponse.prototype.getCurrent = function() {
  return /** @type{?proto.mlmbox.type.Session} */ (
    jspb.Message.getWrapperField(this, mlmbox_type_session_pb.Session, 1));
};


/**
 * @param {?proto.mlmbox.type.Session|undefined} value
 * @return {!proto.mlmbox.client.session.v1.SessionStateGetResponse} returns this
*/
proto.mlmbox.client.session.v1.SessionStateGetResponse.prototype.setCurrent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.mlmbox.client.session.v1.SessionStateGetResponse} returns this
 */
proto.mlmbox.client.session.v1.SessionStateGetResponse.prototype.clearCurrent = function() {
  return this.setCurrent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.mlmbox.client.session.v1.SessionStateGetResponse.prototype.hasCurrent = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated mlmbox.type.Session others = 2;
 * @return {!Array<!proto.mlmbox.type.Session>}
 */
proto.mlmbox.client.session.v1.SessionStateGetResponse.prototype.getOthersList = function() {
  return /** @type{!Array<!proto.mlmbox.type.Session>} */ (
    jspb.Message.getRepeatedWrapperField(this, mlmbox_type_session_pb.Session, 2));
};


/**
 * @param {!Array<!proto.mlmbox.type.Session>} value
 * @return {!proto.mlmbox.client.session.v1.SessionStateGetResponse} returns this
*/
proto.mlmbox.client.session.v1.SessionStateGetResponse.prototype.setOthersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.mlmbox.type.Session=} opt_value
 * @param {number=} opt_index
 * @return {!proto.mlmbox.type.Session}
 */
proto.mlmbox.client.session.v1.SessionStateGetResponse.prototype.addOthers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.mlmbox.type.Session, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.mlmbox.client.session.v1.SessionStateGetResponse} returns this
 */
proto.mlmbox.client.session.v1.SessionStateGetResponse.prototype.clearOthersList = function() {
  return this.setOthersList([]);
};


/**
 * optional uint32 expire_duration = 3;
 * @return {number}
 */
proto.mlmbox.client.session.v1.SessionStateGetResponse.prototype.getExpireDuration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.mlmbox.client.session.v1.SessionStateGetResponse} returns this
 */
proto.mlmbox.client.session.v1.SessionStateGetResponse.prototype.setExpireDuration = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


goog.object.extend(exports, proto.mlmbox.client.session.v1);
